<script>
  import {STATISTICS}           from '../../../constants/statistics';
  import {sizeClass}            from '../../../services/size-class';
  import {results5LimitedStore} from '../../../stores/results/results-5-limited-store';
  import ThSortable             from './th-sortable/th-sortable.svelte';

  const scoreClass = (score) => { // score range = 0.75-5.75
    if (score >= 5)    { return 'results-score-10'; }
    if (score >= 4.5)  { return 'results-score-9'; }
    if (score >= 4.25) { return 'results-score-8'; }
    if (score >= 4)    { return 'results-score-7'; }
    if (score >= 3.75) { return 'results-score-6'; }
    if (score >= 3.5)  { return 'results-score-5'; }
    if (score >= 3.25) { return 'results-score-4'; }
    if (score >= 3)    { return 'results-score-3'; }
    if (score >= 2.5)  { return 'results-score-2'; }
    if (score >= 1.75) { return 'results-score-1'; }
    if (score >= 0.75) { return 'results-score-0'; }
  };
</script>

<style>
  table {
    border: 1px solid #333;
    border-spacing: 0;
    width: 100%;
  }

  #results-table :global(th) {
    background-color: #eee;
  }

  #results-table :global(th),
  #results-table :global(td) {
    border: 1px solid #333;
    padding: 0;
    text-align: center;
  }

  .results-col-parts {
    font-size: 20px;
  }

  .results-part {
    border-bottom: 1px solid #aaa;
  }

  .results-part:last-child {
    border-bottom: none;
  }

  .results-score-0  { background-color: #ffff80; }
  .results-score-1  { background-color: #e5ff99; }
  .results-score-2  { background-color: #ccffb2; }
  .results-score-3  { background-color: #b2ffcc; }
  .results-score-4  { background-color: #99ffe5; }
  .results-score-5  { background-color: #80ffff; }
  .results-score-6  { background-color: #80e5ff; }
  .results-score-7  { background-color: #80ccff; }
  .results-score-8  { background-color: #80b2ff; }
  .results-score-9  { background-color: #8099ff; }
  .results-score-10 { background-color: #8080ff; }

  .results-score-7 .score,
  .results-score-8 .score,
  .results-score-9 .score,
  .results-score-10 .score {
    background: white;
    border-radius: 5px;
    padding: 7px;
  }
</style>

<template lang="pug" src="./results-table.pug"></template>
